import { render, staticRenderFns } from "./Neighborhoods.vue?vue&type=template&id=22a6f43f&scoped=true"
import script from "./Neighborhoods.vue?vue&type=script&lang=js"
export * from "./Neighborhoods.vue?vue&type=script&lang=js"
import style0 from "./Neighborhoods.vue?vue&type=style&index=0&id=22a6f43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6f43f",
  null
  
)

export default component.exports